import React, { useState } from "react";
import { Col, Row, Button, ListGroup, Alert } from "react-bootstrap";

const FileUploader = ({
  id,
  title,
  className = "",
  required = false,
  onChange,
  multiple = false,
  disabled = false,
  label = "Upload File",
  preValue = [],
  size = "sm",
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const internalOnChange = async (e) => {
    const files = e.target.files;
    const fileValues = [];
    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      fileValues.push(await fileToDataURL(file));
    }

    setSelectedFiles(
      multiple ? [...selectedFiles, ...fileValues] : [...fileValues]
    );

    if (onChange) onChange(e);
  };

  const removeFile = (index) => {
    selectedFiles.splice(index, 1);
    setSelectedFiles([...selectedFiles]);
  };

  const triggerFileClick = () => {
    document.getElementById(id).click();
  };

  const count = selectedFiles.length + (preValue ? preValue.length : 0);

  return (
    <div
      className={`border border-muted rounded p-${
        size === "sm" ? "1" : "2"
      } text-center`}
    >
      <div>
        {count > 0 ? (
          <>
            {preValue && preValue.length > 0 && (
              <Row>
                {preValue.map((value) => (
                  <Col xs={12} md={3}>
                    <Alert
                      className={`text-left mb-1 p-1 ${
                        size === "sm" ? "tiny-text" : "small-text"
                      } `}
                      variant="info"
                    >
                      {value}
                    </Alert>
                  </Col>
                ))}
              </Row>
            )}
            {selectedFiles.length > 0 && (
              <div className="mb-1">
                {selectedFiles.map((file, index) => (
                  <Button
                    key={index}
                    name={`${id}-file`}
                    data-name={file.fileName}
                    data-mimetype={file.mimeType}
                    data-value={file.data}
                    className="p-1 mr-1 mb-1"
                    variant="primary"
                    onClick={() => removeFile(index)}
                    size={size}
                  >
                    <h6 className="tiny-text p-0 m-0">
                      {" "}
                      {file.fileName} <span className="ml-2"> x</span>
                    </h6>
                  </Button>
                ))}
              </div>
            )}
          </>
        ) : (
          <h6
            className={`mb-0 p-0 text-center text-secondary ${
              size === "sm" ? "tiny-text" : ""
            }`}
            variant="primary"
          >
            No files uploaded
          </h6>
        )}
      </div>
      {!disabled && (
        <>
          <hr className="m-0" />
          <Button
            className="mt-2 p-1"
            variant="outline-info"
            onClick={triggerFileClick}
            size={size}
          >
            <h6 className="tiny-text p-0 m-0">{label}</h6>
          </Button>
          <input
            required={required}
            id={id}
            type="file"
            onChange={internalOnChange}
            hidden
            multiple={multiple}
          />
        </>
      )}
    </div>
  );
};

function fileToDataURL(file) {
  var reader = new FileReader();
  return new Promise(function(resolve, reject) {
    reader.onload = function(e) {
      const data = e.target.result.split(",");
      const obj = {
        fileName: file.name,
        mimeType: data[0].match(/:(\w.+);/)[1],
        data: data[1],
      };
      resolve(obj);
    };
    reader.readAsDataURL(file);
  });
}

export default FileUploader;
